<template>
  <div>
    <NavBar />
    <b-overlay :show="loading" opacity="0.99">
      <!--create modal-->
      <b-modal
        id="create"
        title="Novo conselho de classe profissional"
        hide-footer
        @show="modalCreateOnShow"
        @shown="modalCreateOnShown"
      >
        <b-form @submit.prevent="create">
          <warning-required-fields />
          <errors-messages :errors="createErrors" />
          <b-row>
            <b-col>
              <label-required-field label="Nome" />
              <b-form-input
                ref="create_autofocus"
                v-model="name"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-right">
              <v-btn type="submit" class="v-success">
                <i class="fa fa-check mr-1"></i> Salvar
              </v-btn>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
      <!--view modal-->
      <b-modal
        id="view"
        title="Conselho de classe profissional"
        hide-footer
        @shown="modalUpdateOnShown"
      >
        <b-form @submit.prevent="update">
          <warning-required-fields />
          <errors-messages :errors="updateErrors" />
          <b-row>
            <b-col>
              <label-required-field label="Nome" />
              <b-form-input
                ref="update_autofocus"
                v-model="name"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-right">
              <v-btn class="v-danger ml-1" @click="remove">
                <i class="fa fa-times-circle mr-1"></i> Apagar
              </v-btn>
              <v-btn type="submit" class="v-success ml-1">
                <i class="fa fa-check mr-1"></i> Salvar
              </v-btn>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
      <!--main view-->
      <b-container class="shadow rounded">
        <b-row>
          <b-col cols="auto">
            <v-btn class="v-primary" v-b-modal.create>
              <i class="fa fa-plus mr-1"></i> Novo
            </v-btn>
          </b-col>
          <b-col cols="auto">
            <h4 class="my-1">Conselho de class profissional</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <v-data-table
              dense
              :headers="headers"
              :items="professional_class_councils"
              :search="search"
              :footer-props="{
                'items-per-page-options': [25, 75, 100],
                'items-per-page-text': 'Mostrar',
              }"
              @click:row="view"
            />
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import api from "../services/api";

import { adminData } from "../lib/functions";
import WarningRequiredFields from "../templates/components/WarningRequiredFields.vue";
import ErrorsMessages from "../templates/components/ErrorsMessages.vue";
import LabelRequiredField from "../templates/components/LabelRequiredField.vue";
import toast from "../components/ToastNotification";

export default {
  name: "Perfis",
  components: {
    NavBar,
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      createErrors: [],
      updateErrors: [],
      loading: false,

      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Nome", value: "name" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      professional_class_councils: [],
      id: "",
      name: "",
    };
  },
  created() {
    this.permissions = adminData().permissions;

    this.get();
  },
  methods: {
    async get() {
      try {
        this.loading = true;

        let response = await api.get("/professional-class-councils");
        let { error, errors, professional_class_councils } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.professional_class_councils = professional_class_councils;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    /** create */
    async modalCreateOnShow() {
      this.name = "";
    },
    async modalCreateOnShown() {
      this.$refs.create_autofocus.focus();
    },
    async create() {
      try {
        this.loading = true;

        let params = { name: this.name };
        let response = await api.post("/professional-class-council", params);
        let { error, errors, message } = response.data;

        if (error) {
          this.createErrors = errors;
        } else {
          this.get();
          this.createErrors = [];
          this.$bvModal.hide("create");
          toast(message, "success");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    /** update */
    async view(item) {
      this.id = item.id;
      this.name = item.name;
      this.$bvModal.show("view");
    },
    async modalUpdateOnShown() {
      this.$refs.update_autofocus.focus();
    },
    async update() {
      try {
        this.loading = true;

        let params = { id: this.id, name: this.name };
        let response = await api.patch("/professional-class-council", params);
        let { error, errors, message } = response.data;

        if (error) {
          this.updateErrors = errors;
        } else {
          this.get();
          this.updateErrors = [];
          this.$bvModal.hide("view");
          toast(message, "success");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async remove() {
      try {
        this.loading = true;

        let params = { id: this.id };
        let response = await api.delete("/professional-class-council", {
          params,
        });
        let { error, errors, message } = response.data;

        if (error) {
          this.updateErrors = errors;
        } else {
          this.get();
          this.updateErrors = [];
          this.$bvModal.hide("view");
          toast(message, "success");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>